import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSort, faSortUp, faSortDown, } from '@fortawesome/free-solid-svg-icons';
var TableHeaderCell = function (_a) {
    var title = _a.title, filterType = _a.filterType, onClick = _a.onClick, _b = _a.sortOrder, sortOrder = _b === void 0 ? 'none' : _b;
    var getIcon = function () {
        if (filterType === 'filter')
            return faFilter;
        if (sortOrder === 'asc')
            return faSortUp;
        if (sortOrder === 'desc')
            return faSortDown;
        return faSort;
    };
    return (React.createElement("button", { onClick: onClick, className: "flex items-center justify-between pr-4 border-r w-full" },
        title,
        React.createElement(FontAwesomeIcon, { icon: getIcon(), size: "sm", className: filterType !== 'filter' && sortOrder === 'none'
                ? 'text-[#C8CEE3]'
                : '' })));
};
export default TableHeaderCell;
